import { RadioGroup } from "@/components/ui/radio-group";
import { InsuranceType } from "./types";
import { useEffect } from "react";
import { insuranceTypes } from "./types/insuranceOptions";
import InsuranceTypeCard from "./InsuranceTypeCard";

interface InsuranceTypeStepProps {
  selectedType: InsuranceType | "";
  onTypeChange: (value: InsuranceType) => void;
  onComplete?: () => void;
}

const InsuranceTypeStep = ({ 
  selectedType, 
  onTypeChange, 
  onComplete 
}: InsuranceTypeStepProps) => {
  useEffect(() => {
    if (selectedType && onComplete) {
      const storedType = sessionStorage.getItem('lastSelectedType');
      if (storedType !== selectedType) {
        const timer = setTimeout(() => {
          sessionStorage.setItem('lastSelectedType', selectedType);
          onComplete();
        }, 500);
        return () => clearTimeout(timer);
      }
    }
  }, [selectedType, onComplete]);

  return (
    <>
      <div className="text-center">
        <h3 className="text-2xl font-bold text-primary-dark">
          Get Your Insurance Quote
        </h3>
        <p className="text-neutral mt-2">
          What type of insurance are you looking for?
        </p>
      </div>

      <RadioGroup
        value={selectedType}
        onValueChange={(value: InsuranceType) => {
          onTypeChange(value);
        }}
        className="grid grid-cols-1 md:grid-cols-2 gap-4"
      >
        {insuranceTypes.map((type) => (
          <InsuranceTypeCard
            key={type.value}
            value={type.value}
            label={type.label}
            icon={type.icon}
            description={type.description}
            isSelected={selectedType === type.value}
          />
        ))}
      </RadioGroup>
    </>
  );
};

export default InsuranceTypeStep;